require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 816
// module chunks = 25